import React, { Component } from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import { Col, Modal, Row, Spin } from 'antd';
import { ModalProps } from 'antd/lib/modal';
import { config } from 'config/config';
import { FormattedMessage } from 'react-intl';

const loadingSpinner = (
  <LoadingOutlined
    style={{
      fontSize: 50,
      color: 'red',
      marginTop: '100px',
      marginBottom: '100px',
    }}
    spin
  />
);

interface OwnProps {
  content: string | React.ReactNode | Element;
  customClass?: string;
  error?: any;
  hideFooter: boolean;
  icon?: string;
  loading: boolean;
  onCancel?: any;
  showIcon?: boolean;
  title?: string | React.ReactNode | Element;
  forceRender?: boolean;
}

type Props = ModalProps & OwnProps;

export default class CustomModal extends Component<Props, {}> {
  public static defaultProps: Partial<Props> = {
    showIcon: true,
    icon: `${config.APP.ASSET_PREFIX}/check_icon.svg`,
    content: '',
  };

  render() {
    const {
      content,
      customClass,
      error,
      hideFooter,
      icon,
      loading,
      showIcon,
      title,
    } = this.props;

    const _iconElement = showIcon ? (
      <img loading="lazy" src={icon} width="106" height="106" />
    ) : null;

    const _contentElement = (
      <Row justify="center">
        {_iconElement}
        {typeof content === 'string' ? (
          <Col style={{ margin: '20px' }}>
            <p
              className="small-body"
              style={{ fontWeight: 700, textAlign: 'center' }}
            >
              {content}
            </p>
          </Col>
        ) : (
          content
        )}
      </Row>
    );

    const getContent = () => {
      if (loading) return <Spin indicator={loadingSpinner} />;
      if (error)
        return (
          <Row justify="center" className="regular-body content-modal">
            {error || <FormattedMessage id="register.submit.error" />}
          </Row>
        );
      return _contentElement;
    };

    const customClassName =
      customClass === 'newsletter-modal'
        ? `${customClass}`
        : `custom-modal ${customClass}`;

    const modalProps = {
      ...this.props,
      className: customClassName,
      centered: true,
    };

    if (!loading && title)
      modalProps.title = (
        <Row justify="center" className="title">
          {title}
        </Row>
      );

    if (hideFooter) modalProps.footer = null;

    return (
      <Modal {...modalProps}>
        <Row justify="center">{getContent()}</Row>
      </Modal>
    );
  }
}
